import { SmallIcon } from "Components/SmallIcon";
import * as DateFns from "date-fns";
import { useField } from "formik";
import React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { Modifier } from "react-day-picker/types/common";
import { renderErrorMessage } from "./Tools";

export const dateFormat = "MM/dd/yyyy";

export function DateInput(props: {
  fieldName: string;
  children?: React.ReactNode;
  label?: string;
  isDisabled?: boolean;
  earliestDate?: Date;
  latestDate?: Date;
  isReadonly?: boolean;
}) {
  const [field, meta] = useField(props.fieldName);
  return (
    <div className="field">
      <div className="control has-icons-left">
        <DayPickerInput
          value={field.value}
          placeholder={dateFormat}
          format={dateFormat}
          formatDate={e => DateFns.format(e, dateFormat)}
          parseDate={e => {
            const date = DateFns.parse(e, dateFormat, new Date());
            if (!DateFns.isValid(date)) {
              return undefined;
            }
            return date;
          }}
          inputProps={{
            id: props.fieldName,
            className: "input",
            disabled: props.isReadonly || props.isDisabled,
            type: "text",
            ...field,
          }}
          dayPickerProps={{
            disabledDays: {
              before: props.earliestDate,
              after: props.latestDate,
            } as Modifier,
          }}
        />
        {props.isReadonly && <input type="hidden" {...field} />}
        {renderErrorMessage(meta)}
        <SmallIcon className="is-left" name="fa-calendar" />
      </div>
    </div>
  );
}
